<template>
  <div class="header_box">
    <div class="top_line_box">
      <div class="w_1200 flex">
        <p class="img"><img src="@/assets/deep_text.png" alt=""></p>
        <div class="right_select flex">
          <!-- <p>
            <a href="javascript:;" target="_blank" rel="noopener noreferrer"
              >资源征集</a
            >
          </p> -->

          <p>
            <a href="http://dlgjxyem.kjcxchina.com/" target="_blank" rel="noopener noreferrer"
              >企业学习管理入口</a
            >
          </p>
          <p>
            <a href="https://dlgjxyapi.kjcxchina.com/" target="_blank" rel="noopener noreferrer"
              >创新工作管理入口</a
            >
          </p>
          
          <!-- <select name="" id="">
            <option value="工会管理端入口" label="工会管理端入口"></option>
          </select> -->
        </div>
      </div>
    </div>
    <div class="head_cont">
      <div class="menu_box w_1200 flex">
        <p class="logo">
          <img src="@/assets/pc/head/logo.png" alt="" />
        </p>
        <ul class="flex titleMenu">
          <li class="post">
              <router-link :class="$route.path=='/'?'activeMenu':''" to="/"
                >首页</router-link
              >

          </li>
          <li class="post">
            <router-link active-class="activeMenu" to="/course/index"
              >学习平台</router-link
            >
          </li>
          <li class="post">
            <router-link active-class="activeMenu" to="/course/list"
              >课程中心</router-link
            >
          </li>

          <li class="item_list" style="display:none;">
            <p>创新工作</p>
            <!-- <router-link active-class="activeMenu" to="/studio/index"
              ></router-link
            > -->
            <div class="sec_list">
                <div>
                  <router-link active-class="activeMenu1" to="/studio/index"
                    >创新工作室</router-link
                  >
               </div>
                <div>
                  <router-link active-class="activeMenu1" to="/achievement/index"
                    >创新成果</router-link
                  >
               </div>
                <div>
                  <router-link active-class="activeMenu1" to="/gjrc/index"
                    >工匠人才</router-link
                  >
               </div>
                <div>
                  <router-link active-class="activeMenu1" to="/project/index"
                    >创新项目</router-link
                  >
               </div>
                <div>
                  <router-link active-class="activeMenu1" to="/problem/index"
                    >疑难攻关</router-link
                  >
               </div>
            </div>
          </li>
          <li class="post">
             <router-link active-class="activeMenu" to="/studio/list"
                    >创新工作室</router-link
                  >
          </li>
          <li class="post">
            <router-link active-class="activeMenu" to="/achievement/achieveList"
              >创新成果</router-link
            >
          </li>
          <li class="post">
            <router-link active-class="activeMenu" to="/gjrc/list"
              >工匠人才</router-link
            >
          </li>
          <!-- 
          
          <li>
            <router-link active-class="activeMenu" to="/project/index"
              >创新项目</router-link
            >
          </li>
          <li>
            <router-link active-class="activeMenu" to="/problem/index"
              >疑难攻关</router-link
            >
          </li> -->
          
          <li class="post">
            <!-- <router-link active-class="activeMenu" to="/skills/index"
              >技能竞赛</router-link
            > -->
           <a href="https://dllmzqx.kjcxchina.com" target="_blank" class="post">助企行</a>
          </li>
          <li class="post">
            <router-link active-class="activeMenu" to="/news_list"
              >新闻中心</router-link
            >
          </li>
        </ul>
        <div class="login_box flex">
          <!-- <p class="search_icon">
            <img src="@/assets/pc/head/search.png" alt="" />
          </p> -->
          <div class="login_state flex">
            <div class="text_login flex" v-if="!userCont">
              <p @click="goLogin()">登录</p>
              <p>/</p>
              <p @click="goRegister()">注册</p>
            </div>
            <div class="per_info" v-else >
              <p class="flex" @click="$router.push('/userData/myClass')">
                <img v-if="user_avater" :src="user_avater" alt="" />
                <img v-else @click="$router.push('/userData/myClass')" src="@/assets/per_img.png" alt="" />
                <span style="margin-left:5px;">个人中心</span>
              </p>
              <div class="sign_out">
                <div class="sign_cont">
                  <div class="btn flex">
                    <!-- <p @click="changMenu('8')">我要反馈</p> -->
                    <p @click="signOut()">退出账号</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录框 -->
    <!-- v-if="loginModal.show" -->
    <Login v-if="loginModal.show" :showIndex="showIndex" />
  </div>
</template>

<script>
import Login from "@/components/pc/login.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "headers",
  data() {
    return {
      showIndex: 1,
      userCont:{},
      user_avater:'',//头像
    };
  },
  props: {
    menu: Array,
    logo: {
      type: String,
      default: "",
    },
  },
  components: {
    Login,
  },
  computed: {
    ...mapState(["tipModal", "loginModal", "userInfo"]),
  },
  mounted() {
    console.log(this.$route.path)
    this.userCont = localStorage.getItem('userData')?JSON.parse(localStorage.getItem('userData')):''
    this.user_avater = localStorage.getItem('user_avater')?JSON.parse(localStorage.getItem('user_avater')):''
    console.log(this.userCont)
  },
  methods: {
    ...mapMutations([
      "ShowLoginModal",
      "CloseLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
      "ShowTipModal",
    ]), //登录弹窗

    // 登录
    goLogin() {
      this.showIndex = 1;
      this.ShowLoginModal();
    },
    // 注册
    goRegister() {
      this.showIndex = 2;
      this.ShowLoginModal();
    },
    // 退出登录
    signOut(){
      localStorage.clear()
      location.reload();
    }
  },
};
</script>

<style scoped lang="scss">
// *{
//   margin: 0;
//   padding: 0;
// }
.header_box {
  height: 113px;
  .top_line_box {
    height: 43px;
    background: #f6f6f6;
    p.img{
      width: 213px;
      height: 21px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    > div {
      justify-content: space-between;
      height: 100%;
      p {
        font-size: 14px;
        color: #333333;
      }
      .right_select {
        p {
          margin-left: 50px;
          cursor: pointer;
        }
        select {
          border: none;
          outline: none;
          background: none;
          color: #333;
        }
      }
    }
  }
  .head_cont {
    height: 70px;
    background: #ffffff;
    box-shadow: 0px 15px 20px 1px rgba(62, 105, 116, 0.1);
     position: relative;
    .menu_box {
      height: 100%;
      p.logo {
        height: 52x;
        margin-right: 55px;
        img {
          width: auto;
          height: 53px;
        }
      }
      ul {
        flex: 1;
        height: 100%;
        justify-content: center;
        li {
          font-size: 14px;
          margin-right: 50px;
          // position: relative;
          height: 100%;
          a {
            line-height: 70px;
          }
        }
        li.post{
          position: relative;
        }
        .item_list{
         position: relative;  
            p{
              line-height: 70px;
            }
            .sec_list{
              position: absolute;
              left: -40px;
              top: 70px;
              background: #fff;
              z-index: 9;
              width: 140px;
              height: 200px;
              // display: flex;
              box-sizing: border-box;
              // padding: 0 20px;
              box-shadow: 0px 15px 20px 1px rgba(62, 105, 116, 0.1);
              border-radius: 0 0 5px 5px;
              justify-content: center;
              display: none;
              div{
                text-align: center;
                height: 40px;
                a{
                  height: 40px;
                  display: block;
                  line-height: 40px;
                }
              }
            }
            .activeMenu1{
              color: #0080ff;
              background: rgba(0, 128, 255, .2);
            }
          
          }
         .item_list:hover{
          .sec_list{
            display: block;
          }
          }
        li:last-child {
          margin-right: 0;
        }
        .activeMenu::after {
          content: "";
          width: 30px;
          height: 2px;
          display: block;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0px;
          background-color: #0080ff;
          border-radius: 30px;
        }
        .activeMenu {
          color: #0080ff;
          font-weight: bold;
        }
      }
    }

    .login_box {
      p.search_icon {
        width: 18px;
        margin-right: 10px;
        img {
          width: 18px;
          display: block;
        }
      }
      .login_state {
        .text_login {
          p {
            font-size: 14px;
            color: #333333;
            margin-right: 2px;
            cursor: pointer;
          }
        }
        .per_info {
          // border-left: 1px solid #e8e8e8;
          margin-left: 21px;
          padding-left: 21px;
          cursor: pointer;
          img {
            width: 27px;
            height: 27px;
            border-radius: 100%;
          }
        }
      }
    }
  }
}
.per_info {
  position: relative;
}
.per_info:hover {
  .sign_out {
    display: block;
  }
}
// 退出登录
.sign_out {
  display: none;
  position: absolute;
  left: -20px;
  top: 25px;
  z-index: 9;
  width: 120px;
  min-height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.05);
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;
  // padding: 20px 20px 12px 20px;

  div.btn {
    margin-top: 14px;
    justify-content: space-between;
    p {
      cursor: pointer;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      flex: 1;
      text-align: center;
    }
  }
}
</style>
